window.addEventListener('DOMContentLoaded', () => {

  // let widget = document.querySelector('.recharge-subscription-widget')
  // let title = document.querySelector('.titleContainer')
  
  // title.insertAdjacentElement("afterend", widget)
})